<template>
  <v-container fill-height fluid class="pa-0" grid-list-lg>
    <v-layout>
      <v-flex xs12>
        <v-toolbar flat dense>
          <v-text-field hide-details single-line readonly :value="propNames">
            <template v-slot:prepend>
              <v-btn small class="ma-0 secondary" @click="selectProperties">Выбрать признаки</v-btn>
            </template>
            <template v-slot:append-outer>
              <span class="grey--text text--darken-2 body-1" v-if="matchCount!=null">Совпадений: {{matchCount}}</span>
              <v-progress-circular indeterminate color="primary" v-else-if="loading"></v-progress-circular>
            </template>
          </v-text-field>
          <v-btn small color="primary" @click="showMatch" v-if="matchCount>0">Показать все</v-btn>
        </v-toolbar>
      
        <v-container fill-height fluid class="pa-2" grid-list-lg>
          <v-layout row wrap class="pt-3" v-if="objectsTree.length>0">
            <v-flex xs12 md4 lg3>
              <v-card>
                <v-system-bar window dark color="accent" style="width: 100%">
                  <v-icon center>mdi-format-list-bulleted-type</v-icon>
                  <v-toolbar-title class="ml-1">Объекты учета</v-toolbar-title>
                </v-system-bar>
                <v-card-text class="objects-list px-0 py-2 ovflowxscroll">
                  <v-treeview :items="objectsTree" v-model="tree" class="densed pb-1" :selectable="objectsTree.length>1" return-object>
                    <template slot="prepend" slot-scope="{ item, open, leaf }">
                      <v-icon size="20" class="mx-0" @contextmenu="openMenu($event, item)">{{item.element_type==='object' ? 'mdi-rhombus-medium' : 'mdi-chart-line'}}</v-icon>
                    </template>
                    <label slot="label" class="pointer" slot-scope="{item}" @contextmenu="openMenu($event, item)" @click="objectValues(item, 'graph')">{{item.name+' ('+item.propsname+')'}}</label>
                  </v-treeview>
                </v-card-text>
              </v-card>
            </v-flex>
          
            <v-flex xs12 md8 lg9 v-if="selectedStatistic">
              <v-card>
                <v-system-bar window dark color="accent" style="width: 100%">
                  <v-icon center>mdi-chart-line</v-icon>
                  <v-toolbar-title class="ml-1">Статистика</v-toolbar-title>
                </v-system-bar>
              
                <v-card-text class="pa-0">
                  <v-flex xs12 class="text-xs-center" v-if="loaded">
                    <template v-if="mode==='table'">
                      <div class="text-xs-center my-3">
                        <span class="pull-left" v-if="statistic.unit">Ед. изм. : {{statistic.unit}}</span>
                        <span class="title blue-grey--text">{{statistic.name}}</span>
                        <v-btn small class="pull-right" color="secondary" @click="objectValues(selectedStatistic, 'graph')">График</v-btn>
                      </div>
                    
                      <v-data-table
                        :headers="headers"
                        :items="items"
                        hide-actions
                        no-data-text="Данные не введены"
                        class="statistic-data-table"
                      >
                        <template slot="items" slot-scope="props">
                          <td class="text-xs-center"> {{ props.item.name }} </td>
                          <td class="text-xs-center" v-for="(el, index) in props.item.data" :key="index">{{el.value}}</td>
                        </template>
                      </v-data-table>
                    </template>
  
                    <template v-else-if="mode==='fill'">
                      <v-flex xs12 v-if="!has_objects" class="text-xs-center py-4 grey--text">
                        <span class="headline">Список объектов пуст. Добавьте объекты для ввода данных.</span>
                      </v-flex>
                      <template v-else>
                        <div class="ma-3 mb-0">
                          <span class="subheading">{{objectsname}}</span>
                          <v-btn color="primary" class="pull-right ma-0" @click="addData" small>Добавить данные</v-btn>
                        </div>
                        <indicator-table :objects="headers_fill" :data="statistic_data" :loading="tableLoading" @save="saveValue" @changeDate="changeDate" canEdit></indicator-table>
                        <div class="text-xs-left">
                          <v-btn v-if="has_data" color="primary" @click="fetchData" small class="my-4">Показать еще данные</v-btn>
                          <p v-else class="pa-4">Все данные загружены</p>
                        </div>
                      </template>
                    </template>
                  
                    <d-statistic v-else :statistic="statistic" :height="7/16*100+'%'" with_periods with_table @change-period="changePeriod($event)" @table-view="tableMode"></d-statistic>
                  </v-flex>
                  <v-flex xs12 class="text-xs-center py-5" v-else>
                    <p>Загрузка ...</p>
                    <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-dialog v-model="dialog" :max-width="dialogWidth" scrollable persistent>
            <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></component>
          </v-dialog>
        </v-container>
      </v-flex>
    
      <v-menu v-model="menu.show" :position-x="menu.x" :position-y="menu.y" absolute offset-y>
        <v-list id="analytics-objects-menu">
          <v-list-tile @click="objectInfo">
            <v-list-tile-action><i class="mdi mdi-information"></i></v-list-tile-action>
            <v-list-tile-title>Информация</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="inputTable(false)">
            <v-list-tile-action><i class="mdi mdi-table-column"></i></v-list-tile-action>
            <v-list-tile-title>Данные объекта</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="inputTable(true)" v-if="tree.length>1 && tree.includes(currentObject)">
            <v-list-tile-action><i class="mdi mdi-table-large"></i></v-list-tile-action>
            <v-list-tile-title>Сводная таблица</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="editObject">
            <v-list-tile-action><i class="mdi mdi-settings"></i></v-list-tile-action>
            <v-list-tile-title>Настройки</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="mergeObjects" v-if="tree.length>1 && tree.includes(currentObject)">
            <v-list-tile-action><i class="mdi mdi-arrow-collapse" style="transform: rotate(45deg);"></i></v-list-tile-action>
            <v-list-tile-title>Объединить выбранные</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-layout>
  </v-container>
  
  
</template>

<script>
  const NAME_SEPARATOR = '\n'
  
  import DStatistic from '../Common/Statistic'
  import IndicatorTable from '../Statistics/IndicatorTable'
  
  import FilterPropertiesForm from './Forms/FilterPropertiesForm'
  import MergeObjectsForm from './Forms/MergeObjectsForm'
  import EditObjectForm from './Forms/EditObjectForm'
  import InfoObjectForm from './Forms/InfoObjectForm'
  import DataDateForm  from '../Statistics/Forms/DataDateForm'
  import entities from '@/mixins/entities'
  import {getNodeByProp, deleteNodeByProp} from "@/helpers/tree"
  import {mapState, mapGetters} from 'vuex'

  export default {
    name : "Filters",
    
    mixins: [entities],
  
    components:{
      DStatistic,
      IndicatorTable
    },
    
    created(){
      this.$store.dispatch('analytics/constructor/getProperties')
    },
    
    computed:{
      ...mapGetters('app/helpers',['formatDatetime']),
      ...mapState(`app/account`, ['postId']),
      headers_fill(){
        return [{
          text: 'Дата',
          align: 'center',
          sortable: false,
          class: 'data-table-header',
          width: 120
        }].concat(this.statistic_objects)
      },
    },
    
    data(){
      return {
        currentComponent: null,
        dialog: false,
        dialogWidth: 1000,
        formProps: {},
        matchCount: null,
        propNames: '',
        properties: [],
        loading: false,
        objectsTree: [],
        menu:{
          x: 0,
          y: 0,
          show: false
        },
        currentObject: null,
        selectedStatistic: null,
        statistic: null,
        loaded: false,
        mode: 'graph',
        tree: [],
        items: [],
        headers: [],
        offset: 0,
        tableLoading: false,
        has_objects: false,
        has_data: false,
        statistic_data: [],
        statistic_objects: [],
        columns: [],
        objectsname: ''
      }
    },
    
    methods: {
      selectProperties(){
        this.formProps = {
          data: this.properties
        }
        this.currentComponent = FilterPropertiesForm
        this.dialog = true
      },
  
      saveChanges(eventData){
        switch(eventData.type){
          case 'selectProperties':
            this.matchCount = 0
            this.propNames = eventData.data.name
            this.properties = eventData.data.properties
            let data = {
              lines:[
                { properties: this.properties, type: 1 }
              ]
            }
            this.loading = true
            this.$store.dispatch('analytics/constructor/countMatch', data).then( response => {
              this.loading = false
              this.matchCount = response.count
            })
            break
          case 'editObject':
            let node = getNodeByProp('id', eventData.data.id, this.objectsTree)
            if(node){
              node.properties = eventData.properties
              node.propsname = eventData.propsname
              this.$store.commit('analytics/constructor/updateObjectProps', node)
            }
            break
          case 'mergeObjects':
            eventData.data.map( item =>{
              this.$store.commit('analytics/constructor/deleteEntity', {id: item.id, trash: false, type: 'object'})
              deleteNodeByProp('id', item.id, this.objectsTree)
            })
            break
          case 'value':
            this.pushRow(eventData)
            break
        }
        this.dialog = false
      },
  
      changePeriod(data){
        data.element_type = 'graph'
        let node = getNodeByProp('id', data.id, this.objectsTree)
        data.properties = node.properties || []
        this.objectValues(data, 'graph')
      },
  
      showMatch(){
        let data = {
          lines:[
            { properties: this.properties, type: 1 }
          ]
        }
        this.$store.dispatch('analytics/constructor/showMatch', data).then( response => {
          this.objectsTree = response
          this.convertUuidsToNames(this.objectsTree)
        })
      },
  
      tableMode(id, period){
        this.mode = 'table'
        this.loaded = false
        if(typeof period==='undefined') period = 0
        let data = {
          properties: this.selectedStatistic.properties,
          offset: null,
          interface_type: 'table',
          period_type: 0
        }
        this.$store.dispatch('analytics/constructor/objectValues', data ).then( response => {
          this.loaded = true
          this.convertOutputSettings(response.lines)
          response.unit = ''
          response.period_type = period
          this.statistic = response
          this.headers = [{
            text: 'Объект',
            sortable: false,
            align: 'center',
            class: 'stat-table-header'
          }]
          response.dates.forEach( item => {
            this.headers.push({
              text: item,
              sortable: false,
              align: 'center',
              class: 'stat-table-header'
            })
          })
    
          this.items = []
          response.lines.forEach( item => {
            let temp = {}
            temp.name = item.name
            temp.data = []
            response.dates.forEach( obj => {
              const index = item.data.findIndex( el => el.date === obj )
              if( index > -1 ) temp.data.push( { value : item.data[ index ].value, date : obj } )
              else temp.data.push( { value : '', date : obj } )
            })
            this.items.push( temp )
          })
        })
      },
  
      objectValues(item, type){
        this.loaded = false
        this.mode = type
        this.selectedStatistic = item
        let data = {
          properties: item.properties,
          offset: null,
          interface_type: type,
          period_type: item.period_type || 0
        }
        this.$store.dispatch('analytics/constructor/objectValues', data).then( response => {
          this.statistic = response
          this.statistic.period_type = data.period_type
          this.loaded = true
        })
      },
  
      openMenu(e, item){
        e.preventDefault()
        this.currentObject = item
        this.menu.show = false
        this.menu.x = e.clientX
        this.menu.y = e.clientY
        this.$nextTick(() => {
          this.menu.show = true
        })
      },
  
      mergeObjects(){
        this.formProps = {
          data: this.tree
        }
        this.currentComponent = MergeObjectsForm
        this.dialog = true
      },
      
      editObject(){
        this.formProps = {
          data: this.currentObject
        }
        this.currentComponent = EditObjectForm
        this.dialog = true
      },
      
      objectInfo(){
        this.formProps = {
          data: this.currentObject
        }
        this.currentComponent = InfoObjectForm
        this.dialog = true
      },
  
      inputTable(multiple){
        this.offset = 0
        this.mode = 'fill'
        this.loaded = false
        this.selectedStatistic = this.currentObject
        this.statistic_data = []
        this.statistic_objects = []
        if(multiple){
          this.columns = this.tree
        } else {
          this.columns = [this.currentObject]
        }
        this.objectsname = ''
        this.columns.map( col => {
          this.objectsname+=col.name+' | '
        })
        this.fetchData()
      },
  
      fetchData(){
        this.tableLoading = true
        this.$store.dispatch('analytics/constructor/getDataTable', {columns: this.columns, offset: this.offset}).then( response => {
          this.loaded = true
          this.tableLoading = false
          this.has_objects = response.lines.length>0
          //Заполнить объекты при их наличии и только при первой загрузке
          if(this.offset===0 && this.has_objects){
            this.convertTableLines(response.lines, this.statistic_objects, NAME_SEPARATOR)
          }
          if(response.data && response.data.length>0){
            this.has_data = true
            this.offset++
            let total = []
        
            response.data.forEach( item => {
              let temp = {}
              temp.date = item.date
              temp.dateFormatted = this.formatDatetime(item.date).dots
              temp.data = []
          
              this.statistic_objects.forEach( obj => {
                const index = item.data.findIndex( el => this.isEqualArrays(el.properties_ids, obj.value) )
                if(index>-1) temp.data.push( {
                  id: item.data[index].id,
                  properties_ids: obj.value,
                  value: item.data[index].value,
                  date: item.date,
                })
                else temp.data.push({properties_ids: obj.value, value: '', date: item.date})
              })
              total.push(temp)
            })
            this.statistic_data = this.statistic_data.concat(total)
          } else {
            this.has_data = false
          }
        })
      },
  
      addData(){
        this.formProps = {}
        this.dialogWidth = 600
        this.currentComponent = DataDateForm
        this.dialog = true
      },
  
      saveValue(item){
        item.filler_id = this.postId
        this.$store.dispatch('analytics/statistics/editData', item).then( response => {
          item.id = response.id
        }).catch( err => {
          item.value = ''+item.prevValue
          if(err.response.status === 403 ) {
            this.$dmsErrorNoty('Ошибка! У вас нет доступа к заполнению этой статистики')
          }
        })
      },
  
      changeDate({row, dateutc, dateFormatted}){
        row.dateFormatted = dateFormatted
        row.date = dateutc
        row.data.map(cell=>{
          cell.date = dateutc
          if(cell.value.toString().length>0){
            this.saveValue(cell)
          }
        })
      },
  
      pushRow(data){
        let temp = {}
        temp.date = data.date
        temp.dateFormatted = data.dateFormatted
        temp.data = []
        temp.selected = true
    
        this.statistic_objects.map( obj => {
          temp.data.push({properties_ids: obj.value, value: '', date: data.date})
        })
    
        let inputIndex = this.statistic_data ? this.statistic_data.length : 0
        this.statistic_data.some( (el, index) => {
          const d1 = new Date(el.date).getTime()
          const d2 = new Date(data.date).getTime()
          if(d2>d1) {
            inputIndex = index
            return true
          }
        })
        this.statistic_data.splice(inputIndex, 0, temp)
    
        this.startTimer()
      },
  
      startTimer(){
        setTimeout( () => {
          this.statistic_data.map( el => {
            el.selected = false
          })
        }, 6000)
      },
  
      isEqualArrays(arr1, arr2){
        if(arr1.length!==arr2.length) return false
        return arr1.every( el => {
          return arr2.includes(el)
        })
      },
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Filters.vue